import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText'
import { AppService } from '../common/AppService'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    '& > label': {
      display: 'block',
      marginBottom: theme.spacing(1),
    },
  },
}));

// TODO: see if you can't use `useField`...current approach feels too manual
type FileFieldProps = {
  label: string,
  name: string,
}
// XXX: the official typing for field is never in the currently published version
//  which seems like a mistake, as how can you set a field value if you can't specify the field?
type overrideFormikContext = {
  errors: { [key:string]: string },
  setFieldTouched: (field: string) => void,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
  touched: { [key:string]: boolean },
  values: { [key:string]: any },
}
const FileField = ({ label, name }: FileFieldProps) => {
  const classes = useStyles();
  // @ts-ignore
  const { errors, setFieldTouched, setFieldValue, touched, values }: overrideFormikContext = useFormikContext();
  
  const handleChange = ({ target }: any) => {
      setFieldTouched(name);
    if (!target.files || target.files.length === 0) {
      setFieldValue(name, '');
      return;
      }

    const file = target.files[0];
    setFieldValue(name, file.name);

    let data = new FormData();
    const storedUser: any = localStorage.getItem('Alutiiq-PreQualificationPortal/user');
    if (storedUser) {
        const user = JSON.parse(storedUser);
        if (user && user.email) {
            data.append('email', user.email);
        }
    }

    data.append('files', file);
    data.append('fieldName', name);
    data.append('fileName', file.name);

    var appService = new AppService();
    appService.saveFile(data);

  };
  const value: string = getIn(values, name);
  const error = getIn(errors, name);
  const isTouched = getIn(touched, name);
  const hasError = isTouched && !! error;

  return (
    <FormControl className={classes.root} error={hasError}>
      <FormLabel>{label}</FormLabel>
      <input type="file" id={name} name={name} onChange={handleChange} style={{ display: 'none' }} />
      <ButtonGroup>
        <Button component="label" htmlFor={name} startIcon={<CloudUploadIcon />} variant="outlined">
          Upload
        </Button>
        {value && (
          <Button disabled>{value}</Button>
        )}
      </ButtonGroup>
      {hasError && (
        <FormHelperText>{error}</FormHelperText>
      )}
    </FormControl>
  );
}

export default FileField;
